export default __webpack_public_path__ + "images/05e2535c77711b7dc22466a0a560deab-lungs.png";